export const sortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;
